module.exports = __webpack_public_path__ + "img/comment.5891a156.jpg";